import { render, staticRenderFns } from "./UserTableClsColumn.vue?vue&type=template&id=43bee3a5&"
import script from "./UserTableClsColumn.vue?vue&type=script&lang=js&"
export * from "./UserTableClsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports